module.exports = __webpack_public_path__ + "static/media/S-6.db6a99ef.mp3";